import { Box, Button, Img, Text } from "@chakra-ui/react";
import React from "react";

import Typewriter from "typewriter-effect";
import styles from "../styles/Hero.module.css";

const TypeWriter = () => {
  return (
    <Box  textAlign={"left"}  w={["300px","340px","35%"]} >
      <Text
        color="white"
        fontWeight={600}
        fontSize={[25,30,40]}
        fontFamily={"monospace"}
      >
        Hello,👋 my name is
      </Text>
      <Text
        className={styles.candidatename}
        color={"white"}
        fontWeight={600}
        fontSize={70}
      >
        Utkarsh
      </Text>

      <Box
        fontSize={["25px","25px","30px"]}
        fontWeight={500}
        color="white"
        textDecoration="underline"
      >
        <Typewriter
          className={styles.typing}
          options={{
            strings: ["Full Stack Developer", "MERN stack developer"],
            autoStart: true,
            smooth: true,
            loop: true,
          }}
        />
      </Box>
      
      
    </Box>
  );
};

export default TypeWriter;
